import {
  StylesDerivedNativeActionNames,
  StylesDerivedNativeActions,
} from '@wix/editor-platform-host-integration-apis';
import borderAction from './border';
import cornerAction from './corner';
import filterAction from './filter';
import shadowAction from './shadow';
import spacingAction from './spacing';
import strokeAction from './stroke';
import textAction from './text';
import { GlobalDesignGroupAction, GlobalDesignDefaultAction } from './types';

export const GLOBAL_DESIGN_GROUPS_ACTIONS: Partial<
  Record<StylesDerivedNativeActionNames, GlobalDesignGroupAction>
> = {
  [StylesDerivedNativeActions.borderStyles]: borderAction,
  [StylesDerivedNativeActions.cornerStyles]: cornerAction,
  [StylesDerivedNativeActions.filterStyles]: filterAction,
  [StylesDerivedNativeActions.shadowStyles]: shadowAction,
  [StylesDerivedNativeActions.textStyles]: textAction,
  [StylesDerivedNativeActions.strokeStyles]: strokeAction,
};

export const GLOBAL_DESIGN_DEFAULT_ACTIONS: Partial<
  Record<StylesDerivedNativeActionNames, GlobalDesignDefaultAction>
> = {
  [StylesDerivedNativeActions.spacingStyles]: spacingAction,
};

export const GLOBAL_DESIGN_ACTIONS = {
  ...GLOBAL_DESIGN_GROUPS_ACTIONS,
  ...GLOBAL_DESIGN_DEFAULT_ACTIONS,
};
